import { html, nothing } from "lit";
import "../../atom/Icon/index.js";
import "../IconButton/index.js";
import "../Link/index.js";
import "../Badge/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { getIconName, getContainerClasses, getBackgroundColorClass } from "./utils.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./toast.selectors.js";
import { rif } from "../../../helpers/renderIf.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
function toBadgeLevel(type) {
  if (type === "error") {
    return "critical";
  }
  return type;
}
let DsfToast = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_type = "info";
    this.dsf_closable = true;
    this.dsf_clickable = true;
  }
  onClose() {
    this.emit("close");
  }
  onClick(event) {
    if (this.dsf_clickable) {
      this.emit({ name: "click", payload: event });
    }
  }
  ctaLinkClick() {
    this.emit("call-to-action");
  }
  render() {
    const closeButton = this.dsf_closable ? html`<dsf-icon-button
          dsf_icon="X"
          dsf_size="small"
          .dsf_title=${this.dsf_close_button_title}
          @click="${this.onClose}"
          class="close-icon absolute right-0 top-0 m-4"
          ${testingAttr(TestingAttrs.closeButton)}
        >
        </dsf-icon-button>` : nothing;
    const mainIcon = html`<dsf-badge
      class="ml-8"
      dsf_level=${toBadgeLevel(this.dsf_type)}
      dsf_icon_left=${this.dsf_icon || getIconName(this.dsf_type)}
    >
    </dsf-badge>`;
    const callToAction = this.dsf_call_to_action ? html`<dsf-link
          dsf_size="medium"
          class="mt-4 max-w-fit"
          @click=${this.ctaLinkClick}
          ${testingAttr(TestingAttrs.ctaLink)}
        >
          ${this.dsf_call_to_action}
        </dsf-link>` : nothing;
    const containerClasses = getContainerClasses(this);
    return html`
      <div @click="${this.onClick}" class="${containerClasses}" data-skeleton>
        ${closeButton}
        <div
          class="${getBackgroundColorClass(this.dsf_type)} h-full w-8 min-w-8 rounded-l-sm"
        ></div>
        <div class="icon-area my-10">${mainIcon}</div>
        <div class="flex flex-col gap-4 overflow-hidden px-12 py-8">
          ${rif(
      this.dsf_title,
      html`<span class="dsf-text-s-medium truncate text-wrap pr-12">${this.dsf_title}</span>`
    )}
          <span class="dsf-text-xs mt-2 truncate text-wrap"> ${this.dsf_message}</span>
          ${callToAction}
        </div>
      </div>
    `;
  }
};
DsfToast.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
__decorateClass([
  prop({ type: String, reflect: true })
], DsfToast.prototype, "dsf_type", 2);
__decorateClass([
  prop({ type: String })
], DsfToast.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: String })
], DsfToast.prototype, "dsf_message", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfToast.prototype, "dsf_closable", 2);
__decorateClass([
  prop({ type: String })
], DsfToast.prototype, "dsf_close_button_title", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfToast.prototype, "dsf_clickable", 2);
__decorateClass([
  prop({ type: String })
], DsfToast.prototype, "dsf_call_to_action", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfToast.prototype, "dsf_icon", 2);
__decorateClass([
  preventDefault
], DsfToast.prototype, "onClose", 1);
__decorateClass([
  preventDefault
], DsfToast.prototype, "onClick", 1);
DsfToast = __decorateClass([
  defineElement("dsf-toast")
], DsfToast);
export {
  DsfToast
};
